import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import Swal from '../../shared/utils/swal.util';

@Injectable()
export class SuccessInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // A tela pede `skip-success` quando ela mesma já dá o retorno da ação.
    const skipSuccess = request.headers.get('skip-success') === 'true';

    const handledRequest = skipSuccess
      ? request.clone({ headers: request.headers.delete('skip-success') })
      : request;

    return next.handle(handledRequest).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && !skipSuccess) {
          const isMutation =
            ['POST', 'PUT', 'PATCH', 'DELETE'].includes(request.method);

          const forceShow = request.headers.get('show-success') === 'true';

          const successMessage =
            event.body?.message ||
            event.body?.Message ||
            event.body?.msg ||
            '';

          if ((isMutation || forceShow) && successMessage) {
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Sucesso',
              text: successMessage,
              timer: 4000,
              showConfirmButton: false,
            });
          }
        }
      })
    );
  }
}
